var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Open-link") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.3999798,10.3999472 L22.3999798,23.1999265 C22.3999798,23.4124261 22.3156039,23.6155658 22.1656042,23.7655656 C22.0156044,23.9155653 21.8124807,23.9999412 21.5999651,23.9999412 L0.799998707,23.9999412 C0.357799422,23.9999412 0,23.6421298 0,23.1999425 L0,2.39997612 C0,1.95777683 0.357811422,1.59997741 0.799998707,1.59997741 L13.599978,1.59997741 C14.0421773,1.59997741 14.3999767,1.95778883 14.3999767,2.39997612 C14.3999767,2.84216341 14.0421653,3.19997483 13.599978,3.19997483 L1.59999741,3.19997483 L1.59999741,22.3999438 L20.7999664,22.3999438 L20.7999664,10.3999632 C20.7999664,9.9577639 21.1577778,9.59996448 21.5999651,9.59996448 C22.0421524,9.59996448 22.3999798,9.9577759 22.3999798,10.3999632 L22.3999798,10.3999472 Z M23.9390573,0.501563189 C23.8828094,0.373439396 23.7921815,0.262499576 23.6781217,0.181251707 C23.6531218,0.16093934 23.6265578,0.143751768 23.5984338,0.126563795 C23.479682,0.0484399217 23.3421863,0.00468799242 23.1999985,0 L16.8000088,0 C16.3578096,0 16.0000101,0.357811422 16.0000101,0.799998707 C16.0000101,1.24218599 16.3578216,1.59999741 16.8000088,1.59999741 L21.2688016,1.59999741 L11.4328175,11.4343815 L11.4343803,11.4343815 C11.1203168,11.746881 11.1203168,12.2531402 11.4343803,12.5656197 C11.7468798,12.8796832 12.253139,12.8796832 12.5656185,12.5656197 L22.4000026,2.73123558 L22.4000026,7.20002836 C22.4000026,7.64222765 22.757814,8.00002707 23.2000013,8.00002707 C23.6421886,8.00002707 24,7.64221565 24,7.20002836 L24,0.800038707 C24,0.696914873 23.9796876,0.595351038 23.9390641,0.501603189 L23.9390573,0.501563189 Z",
    id: "path-1",
    fill: "#0095FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Open-link"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "BoundingBox",
    points: "0 0 24 0 24 24 19.6933594 24 0 24"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#0095FF"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#0095FF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#0095FF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-\\uD83C\\uDFA8IconBg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ColorBg",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLink);
export default __webpack_public_path__ + "static/media/open-link.fa45b574228aacfc1accfadb1e9b1bac.svg";
export { ForwardRef as ReactComponent };